var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-pagination',{attrs:{"length":_vm.pageCount,"loading":_vm.loading},model:{value:(_vm.tableOptions.page),callback:function ($$v) {_vm.$set(_vm.tableOptions, "page", $$v)},expression:"tableOptions.page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }